import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressionUpdateCard = ({ update }) => {
  const formatTimestamp = (date) => {
    const now = new Date();
    const diff = now - date;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const days = Math.floor(hours / 24);

    if (days > 0) return `${days}d ago`;
    if (hours > 0) return `${hours}h ago`;
    return 'Just now';
  };

  const getAchievementIcon = (type) => {
    switch (type) {
      case 'boss':
        return 'Skull';
      case 'quest':
        return 'ScrollText';
      case 'milestone':
        return 'Trophy';
      default:
        return 'Star';
    }
  };

  return (
    <div className="flex items-start gap-3 p-4 rounded-xl bg-muted hover:bg-card transition-base border border-border">
      <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary flex items-center justify-center">
        <Icon name={getAchievementIcon(update?.type)} size={20} color="var(--color-primary-foreground)" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1">
          <span className="text-sm md:text-base font-semibold text-foreground truncate">
            {update?.characterName}
          </span>
          <span className="text-xs text-muted-foreground flex-shrink-0">
            {formatTimestamp(update?.timestamp)}
          </span>
        </div>
        <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">
          {update?.achievement}
        </p>
        {update?.progress && (
          <div className="mt-2">
            <div className="flex items-center justify-between mb-1">
              <span className="text-xs text-muted-foreground">{update?.contentArea}</span>
              <span className="text-xs font-medium text-foreground">{update?.progress}%</span>
            </div>
            <div className="character-progress">
              <div 
                className="character-progress-bar" 
                style={{ width: `${update?.progress}%` }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgressionUpdateCard;